export default {
  init() {
    // JavaScript to be fired on the graphs page
    // buttons
    $('#butPrint').click(function() {
      window.print(); 
    });
    
    // make global, since webpack uses enclosures to scope partials
    window.mhpa = window.mhpa || {};
    window.mhpa.loadAccountData = function() {

      $.get('/rrtpbillcompare/Servlet?type=has-base-data&account=' + $('#account').val(), function(data) {
        // 2019016 updated per request JMJ
        //if (data == 'net-metered') {
        //    $.fancybox({
        //    	href: "#net-metered"
        //	});
        //} else {
        //    $('.' + data).show();
        //}
        if (data.indexOf('main-wrap') >= 0) {
          $('.main-wrap').show();
        } else {
          $('.no-data').show();
        }
      });
      // Checks if NM user //
      $.ajax({
        url: '/rrtpbillcompare/Servlet?type=is-netmeter&account=' + $('#account').val(), // Search rrtpbc servlet.java for "is-netmeter" to find corresponding java code
        success: function(data) {
         $('.graphContainer').hide();
         // user is net-metering participant (1) || or NM + community generation (19)
          if (data == 'rider1' || data == 'rider19') { 
            $('#net-grid-consumption-chart').show();
            $('#kWh-to-grid-chart').show();
            $('#kWh-from-grid-chart').show();
          } 
          // NM 5  
          else if (data == 'rider5'){
            console.log('rider5 detected')
            $('#kWh-from-grid-chart').show();
            $('#hourly-generation-credit-chart').show();
            $('#total-electricity-charges-chart').show();
          } 
          // user is standard && community generation (9)
          else if (data == 'rider9'){ 
            $('#electricity-usage-chart').show();
            $('#total-electricity-charges-chart').show();
            $('#average-electricity-charges-chart').show();
          } 
          // regular user
          else { 
            $('#electricity-usage-chart').show();
            $('#total-electricity-charges-chart').show();
            $('#average-electricity-charges-chart').show();
          }
        },
        cache: false,
        async: false,
      });

      // NET-CONSUMPTION-CHART //
      $.getJSON('/rrtpbillcompare/Servlet?type=net-grid-consumption-chart&account=' + $('#account-select #account').val(), function(json) {
        //console.log(json);
        // changes to make data conform to JSON spec
        json.chartData1 = json.chartData1.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        json.chartData2 = json.chartData2.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        json.chartData3 = json.chartData3.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        $('#spinner-net-consumption-chart').hide();
        Highcharts.chart('net-grid-consumption-chart', {
          chart: {
            type: 'column',
            description: 'Average electricity charges broken down by month for three years in cents per kilowatt hour.',
            height: 230, // Responsive Solution: Remove Width. 2019-02-20//
          },
          credits: {
            enabled: false,
          },
          title: {
            text: json.title,
            style: {
              color: '#170d67',
              fontFamily: 'Open Sans',
              fontWeight: '700',
            },
          },
          subtitle: {
            text: '',
          },
          xAxis: {
            lineColor: '#170d67',
            //categories: eval(json.xAxisCategories),   // if turned back on, change eval to JSON.parse.  May require changes in the data to confirm to JSON format
            labels: {
              formatter: function() {
                if (this.value == '1') return 'Jan';
                else if (this.value == '2') return 'Feb';
                else if (this.value == '3') return 'Mar';
                else if (this.value == '4') return 'Apr';
                else if (this.value == '5') return 'May';
                else if (this.value == '6') return 'Jun';
                else if (this.value == '7') return 'Jul';
                else if (this.value == '8') return 'Aug';
                else if (this.value == '9') return 'Sep';
                else if (this.value == '10') return 'Oct';
                else if (this.value == '11') return 'Nov';
                else if (this.value == '12') return 'Dec';
              },
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            },
          },
          yAxis: {
            lineColor: '#170d67',
            gridLineColor: '#170d67',
            title: {
              enabled: true,
              text: json.yAxis,
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            },
            labels: {
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            }
          },
          tooltip: {
            //headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            //pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            //   '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
            //footerFormat: '</table>',
            enabled: true,
            headerFormat: '',
            pointFormat: '{point.y:.1f} kWh',
            //shared: true,
            //useHTML: true
          },
          plotOptions: {
            series: {
              cursor: 'pointer',
              point: {
                events: {
                  click: function() {
                    //console.log('ID: ' + this.id + ' Name: ' + this.series.name + ' Category: ' + this.category + ', y: ' + this.y);
                    window.location = '/bc-graphs-daily?account=' + $('#account-select #account').val() + '&date=' + this.id;
                  },
                },
	      },
            },
            column: {
              pointPadding: 0.2,
              borderWidth: 0,
            },
          },
          series: [{
            name: json.seriesName1,
            data: JSON.parse(json.chartData1),
            color: '#170d67',
          }, {
            name: json.seriesName2,
            data: JSON.parse(json.chartData2),
            color: '#6e06c1',
         }, {
            name: json.seriesName3,
            data: JSON.parse(json.chartData3),
            color: '#3a5cff',
          }],
          // Added to test responsive. 12/12/2018 //
          /*	         responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    legend: {
                        align: 'center',
                        verticalAlign: 'bottom',
                        layout: 'horizontal'
                    },
                    yAxis: {
                        labels: {
                            align: 'left',
                            x: 0,
                            y: -5
                        },
                        title: {
                            text: null
                        }
                    },
                    subtitle: {
                        text: null
                    },
                    credits: {
                        enabled: false
                    }
                }
            }]
        } */ // End addition //
        });
      });

   	// hourly credits chart (rider 5)
	   $.getJSON('/rrtpbillcompare/Servlet?type=hourly-generation-credit-chart&account=' + $('#account-select #account').val(), function(json) {
        // changes to make data conform to JSON spec
        json.chartData1 = json.chartData1.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        json.chartData2 = json.chartData2.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        json.chartData3 = json.chartData3.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        $('#spinner-hourly-generation-credit-chart').hide();
        Highcharts.chart('hourly-generation-credit-chart',{
          chart: {
            type: 'column',
            description: 'Average electricity charges broken down by month for three years in cents per kilowatt hour.',
            height: 230, // Responsive Solution: Remove Width. 2019-02-20//
          },
          credits: {
            enabled: false,
          },
          title: {
            text: json.title,
          },
          subtitle: {
            text: '',
          },
          xAxis: {
            //categories: eval(json.xAxisCategories),   // if turned back on, change eval to JSON.parse.  May require changes in the data to confirm to JSON format
            labels: {
              formatter: function() {
                if (this.value == '1') return 'Jan';
                else if (this.value == '2') return 'Feb';
                else if (this.value == '3') return 'Mar';
                else if (this.value == '4') return 'Apr';
                else if (this.value == '5') return 'May';
                else if (this.value == '6') return 'Jun';
                else if (this.value == '7') return 'Jul';
                else if (this.value == '8') return 'Aug';
                else if (this.value == '9') return 'Sep';
                else if (this.value == '10') return 'Oct';
                else if (this.value == '11') return 'Nov';
                else if (this.value == '12') return 'Dec';
              },
            },
          },
          yAxis: {
            title: {
              enabled: true,
              text: json.yAxis,
            },
          },
          tooltip: {
            //headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            //pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            //   '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
            //footerFormat: '</table>',
            enabled: true,
            headerFormat: '',
            pointFormat: '{point.y:.1f} kWh',
            //shared: true,
            //useHTML: true
          },
          plotOptions: {
            series: {
              cursor: 'pointer',
              point: {
                events: {
                  click: function() {
                    //console.log('ID: ' + this.id + ' Name: ' + this.series.name + ' Category: ' + this.category + ', y: ' + this.y);
                    window.location = '/bc-graphs-daily?account=' + $('#account-select #account').val() + '&date=' + this.id;
                  },
                },
              },
              borderRadius: 0
            },
            column: {
              pointPadding: 0.2,
              borderWidth: 0,
            },
          },
          series: [{
            name: json.seriesName1,
            data: JSON.parse(json.chartData1),
            color: '#170d67',
          }, {
            name: json.seriesName2,
            data: JSON.parse(json.chartData2),
            color: '#6e06c1',
         }, {
            name: json.seriesName3,
            data: JSON.parse(json.chartData3),
            color: '#3a5cff',
          }],
          // Added to test responsive. 12/12/2018 //
          /*	         responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    legend: {
                        align: 'center',
                        verticalAlign: 'bottom',
                        layout: 'horizontal'
                    },
                    yAxis: {
                        labels: {
                            align: 'left',
                            x: 0,
                            y: -5
                        },
                        title: {
                            text: null
                        }
                    },
                    subtitle: {
                        text: null
                    },
                    credits: {
                        enabled: false
                    }
                }
            }]
        } */ // End addition //
        });
      });

      // local-consumption-chart //
      $.getJSON('/rrtpbillcompare/Servlet?type=kWh-to-grid-chart&account=' + $('#account-select #account').val(), function(json) {
        // changes to make data conform to JSON spec
        json.chartData1 = json.chartData1.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        json.chartData2 = json.chartData2.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        json.chartData3 = json.chartData3.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        $('#spinner-local-consumption-chart').hide();
        Highcharts.chart('kWh-to-grid-chart',{
          chart: {
            type: 'column',
            description: 'Average electricity charges broken down by month for three years in cents per kilowatt hour.',
            height: 230, // Responsive Solution: Remove Width. 2019-02-20//
          },
          credits: {
            enabled: false,
          },
          title: {
            text: json.title,
            style: {
              color: '#170d67',
              fontFamily: 'Open Sans',
              fontWeight: '700',
            },
          },
          subtitle: {
            text: '',
          },
          xAxis: {
            lineColor: '#170d67',
            //categories: eval(json.xAxisCategories),   // if turned back on, change eval to JSON.parse.  May require changes in the data to confirm to JSON format
            labels: {
              formatter: function() {
                if (this.value == '1') return 'Jan';
                else if (this.value == '2') return 'Feb';
                else if (this.value == '3') return 'Mar';
                else if (this.value == '4') return 'Apr';
                else if (this.value == '5') return 'May';
                else if (this.value == '6') return 'Jun';
                else if (this.value == '7') return 'Jul';
                else if (this.value == '8') return 'Aug';
                else if (this.value == '9') return 'Sep';
                else if (this.value == '10') return 'Oct';
                else if (this.value == '11') return 'Nov';
                else if (this.value == '12') return 'Dec';
              },
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            },
          },
          yAxis: {
            lineColor: '#170d67',
            gridLineColor: '#170d67',
            title: {
              enabled: true,
              text: json.yAxis,
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            },
            labels: {
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            }
          },
          tooltip: {
            //headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            //pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            //   '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
            //footerFormat: '</table>',
            enabled: true,
            headerFormat: '',
            pointFormat: '{point.y:.1f} kWh',
            //shared: true,
            //useHTML: true
          },
          plotOptions: {
            series: {
              cursor: 'pointer',
              point: {
                events: {
                  click: function() {
                    //console.log('ID: ' + this.id + ' Name: ' + this.series.name + ' Category: ' + this.category + ', y: ' + this.y);
                    window.location = '/bc-graphs-daily?account=' + $('#account-select #account').val() + '&date=' + this.id;
                  },
                },
              },
              borderRadius: 0
            },
            column: {
              pointPadding: 0.2,
              borderWidth: 0,
            },
          },
          series: [{
            name: json.seriesName1,
            data: JSON.parse(json.chartData1),
            color: '#170d67',
          }, {
            name: json.seriesName2,
            data: JSON.parse(json.chartData2),
            color: '#6e06c1',
         }, {
            name: json.seriesName3,
            data: JSON.parse(json.chartData3),
            color: '#3a5cff',
          }],
          // Added to test responsive. 12/12/2018 //
          /*	         responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    legend: {
                        align: 'center',
                        verticalAlign: 'bottom',
                        layout: 'horizontal'
                    },
                    yAxis: {
                        labels: {
                            align: 'left',
                            x: 0,
                            y: -5
                        },
                        title: {
                            text: null
                        }
                    },
                    subtitle: {
                        text: null
                    },
                    credits: {
                        enabled: false
                    }
                }
            }]
        } */ // End addition //
        });
      });

      // nm-CONSUMPTION-CHART //
      $.getJSON('/rrtpbillcompare/Servlet?type=kWh-from-grid-chart&account=' + $('#account-select #account').val(), function(json) {
        //console.log(json);
        // changes to make data conform to JSON spec
        json.chartData1 = json.chartData1.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        json.chartData2 = json.chartData2.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        json.chartData3 = json.chartData3.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        $('#spinner-nm-consumption-chart').hide();
        Highcharts.chart('kWh-from-grid-chart',{
          chart: {
            type: 'column',
            description: 'Average electricity charges broken down by month for three years in cents per kilowatt hour.',
            height: 230, // Responsive Solution: Remove Width. 2019-02-20//
          },
          credits: {
            enabled: false,
          },
          title: {
            text: json.title,
            style: {
              color: '#170d67',
              fontFamily: 'Open Sans',
              fontWeight: '700',
            },
          },
          subtitle: {
            text: '',
          },
          xAxis: {
            lineColor: '#170d67',
            //categories: eval(json.xAxisCategories),  // if turned back on, change eval to JSON.parse.  May require changes in the data to confirm to JSON format
            labels: {
              formatter: function() {
                if (this.value == '1') return 'Jan';
                else if (this.value == '2') return 'Feb';
                else if (this.value == '3') return 'Mar';
                else if (this.value == '4') return 'Apr';
                else if (this.value == '5') return 'May';
                else if (this.value == '6') return 'Jun';
                else if (this.value == '7') return 'Jul';
                else if (this.value == '8') return 'Aug';
                else if (this.value == '9') return 'Sep';
                else if (this.value == '10') return 'Oct';
                else if (this.value == '11') return 'Nov';
                else if (this.value == '12') return 'Dec';
              },
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            },
          },
          yAxis: {
            lineColor: '#170d67',
            gridLineColor: '#170d67',
            title: {
              enabled: true,
              text: json.yAxis,
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            },
            labels: {
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            }
          },
          tooltip: {
            //headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            //pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            //   '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
            //footerFormat: '</table>',
            enabled: true,
            headerFormat: '',
            pointFormat: '{point.y:.1f} kWh',
            //shared: true,
            //useHTML: true
          },
          plotOptions: {
            series: {
              cursor: 'pointer',
              point: {
                events: {
                  click: function() {
                    //console.log('ID: ' + this.id + ' Name: ' + this.series.name + ' Category: ' + this.category + ', y: ' + this.y);
                    window.location = '/bc-graphs-daily?account=' + $('#account-select #account').val() + '&date=' + this.id;
                  },
                },
              },
              borderRadius: 0
            },
            column: {
              pointPadding: 0.2,
              borderWidth: 0,
            },
          },
          series: [{
            name: json.seriesName1,
            data: JSON.parse(json.chartData1),
            color: '#170d67',
          }, {
            name: json.seriesName2,
            data: JSON.parse(json.chartData2),
            color: '#6e06c1',
         }, {
            name: json.seriesName3,
            data: JSON.parse(json.chartData3),
            color: '#3a5cff',
          }],
          // Added to test responsive. 12/12/2018 //
          /*	         responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    legend: {
                        align: 'center',
                        verticalAlign: 'bottom',
                        layout: 'horizontal'
                    },
                    yAxis: {
                        labels: {
                            align: 'left',
                            x: 0,
                            y: -5
                        },
                        title: {
                            text: null
                        }
                    },
                    subtitle: {
                        text: null
                    },
                    credits: {
                        enabled: false
                    }
                }
            }]
        } */ // End addition //
        });
      });
      // ENd of NM additions

      // CONSUMPTION-CHART //
      $.getJSON('/rrtpbillcompare/Servlet?type=electricity-usage-chart&account=' + $('#account-select #account').val(), function(json) {
        //console.log('consumption-chart ::');
        //console.log(json);
        // changes to make data conform to JSON spec
        json.chartData1 = json.chartData1.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        json.chartData2 = json.chartData2.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        json.chartData3 = json.chartData3.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        $('#spinner-consumption-chart').hide();
        Highcharts.chart('electricity-usage-chart',{
          chart: {
            type: 'column',
            description: 'Average electricity charges broken down by month for three years in cents per kilowatt hour.',
            height: 230, // Responsive Solution: Remove Width. 2019-02-20//
          },
          credits: {
            enabled: false,
          },
          title: {
            text: json.title,
            style: {
              color: '#170d67',
              fontFamily: 'Open Sans',
              fontWeight: '700',
            },
          },
          subtitle: {
            text: '',
          },
          xAxis: {
            lineColor: '#170d67',
            //categories: eval(json.xAxisCategories),  // if turned back on, change eval to JSON.parse.  May require changes in the data to confirm to JSON format
            labels: {
              formatter: function() {
                if (this.value == '1') return 'Jan';
                else if (this.value == '2') return 'Feb';
                else if (this.value == '3') return 'Mar';
                else if (this.value == '4') return 'Apr';
                else if (this.value == '5') return 'May';
                else if (this.value == '6') return 'Jun';
                else if (this.value == '7') return 'Jul';
                else if (this.value == '8') return 'Aug';
                else if (this.value == '9') return 'Sep';
                else if (this.value == '10') return 'Oct';
                else if (this.value == '11') return 'Nov';
                else if (this.value == '12') return 'Dec';
              },
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            },
          },
          yAxis: {
            lineColor: '#170d67',
            gridLineColor: '#170d67',
            title: {
              enabled: true,
              text: json.yAxis,
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            },
            labels: {
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            }
          },
          tooltip: {
            //headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            //pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            //   '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
            //footerFormat: '</table>',
            enabled: true,
            headerFormat: '',
            pointFormat: '{point.y:.1f} kWh',
            //shared: true,
            //useHTML: true
          },
          plotOptions: {
            series: {
              cursor: 'pointer',
              point: {
                events: {
                  click: function() {
                    //console.log('ID: ' + this.id + ' Name: ' + this.series.name + ' Category: ' + this.category + ', y: ' + this.y);
                    window.location = '/bc-graphs-daily?account=' + $('#account-select #account').val() + '&date=' + this.id;
                  },
                },
              },
              borderRadius: 0
            },
            column: {
              pointPadding: 0.2,
              borderWidth: 0,
            },
          },
          series: [{
            name: json.seriesName1,
            data: JSON.parse(json.chartData1),
            color: '#170d67',
          }, {
            name: json.seriesName2,
            data: JSON.parse(json.chartData2),
            color: '#6e06c1',
         }, {
            name: json.seriesName3,
            data: JSON.parse(json.chartData3),
            color: '#3a5cff',
          }],
          // Added to test responsive. 12/12/2018 //
          /*	         responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    legend: {
                        align: 'center',
                        verticalAlign: 'bottom',
                        layout: 'horizontal'
                    },
                    yAxis: {
                        labels: {
                            align: 'left',
                            x: 0,
                            y: -5
                        },
                        title: {
                            text: null
                        }
                    },
                    subtitle: {
                        text: null
                    },
                    credits: {
                        enabled: false
                    }
                }
            }]
        } */ // End addition //
        });
      });

      // HOURLY-CHARGES-CHART //
      $.getJSON('/rrtpbillcompare/Servlet?type=total-electricity-charges-chart&account=' + $('#account-select #account').val(), function(json) {
        //console.log('hourly-charges-chart');
        //console.log(json);
        // changes to make data conform to JSON spec
        json.chartData1 = json.chartData1.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        json.chartData2 = json.chartData2.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        json.chartData3 = json.chartData3.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        $('#spinner-hourly-charges-chart').hide();
        Highcharts.chart('total-electricity-charges-chart',{
          chart: {
            type: 'column',
            description: 'Electricity Usage broken down by month for three years in kilowatt hours.',
            height: 230,
          },
          credits: {
            enabled: false,
          },
          title: {
            text: json.title,
            style: {
              color: '#170d67',
              fontFamily: 'Open Sans',
              fontWeight: '700',
            },
          },
          subtitle: {
            text: '',
          },
          xAxis: {
            lineColor: '#170d67',
            //categories: eval(json.xAxisCategories),  // if turned back on, change eval to JSON.parse.  May require changes in the data to confirm to JSON format
            labels: {
              formatter: function() {
                if (this.value == '1') return 'Jan';
                else if (this.value == '2') return 'Feb';
                else if (this.value == '3') return 'Mar';
                else if (this.value == '4') return 'Apr';
                else if (this.value == '5') return 'May';
                else if (this.value == '6') return 'Jun';
                else if (this.value == '7') return 'Jul';
                else if (this.value == '8') return 'Aug';
                else if (this.value == '9') return 'Sep';
                else if (this.value == '10') return 'Oct';
                else if (this.value == '11') return 'Nov';
                else if (this.value == '12') return 'Dec';
              },
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            },
          },
          yAxis: {
            lineColor: '#170d67',
            gridLineColor: '#170d67',
            title: {
              enabled: true,
              text: json.yAxis,
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            },
            labels: {
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            }
          },
          tooltip: {
            //headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            //pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            //   '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
            //footerFormat: '</table>',
            enabled: true,
            headerFormat: '',
            pointFormat: '${point.y:.2f}',
            //shared: true,
            //useHTML: true
          },
          plotOptions: {
            series: {
              cursor: 'pointer',
              point: {
                events: {
                  click: function() {
                    //console.log('ID: ' + this.id + ' Name: ' + this.series.name + ' Category: ' + this.category + ', y: ' + this.y);
                    window.location = '/bc-graphs-daily?account=' + $('#account-select #account').val() + '&date=' + this.id;
                  },
                },
              },
              borderRadius: 0
            },
            column: {
              pointPadding: 0.2,
              borderWidth: 0,
            },
          },
          series: [{
            name: json.seriesName1,
            data: JSON.parse(json.chartData1),
            color: '#170d67',
          }, {
            name: json.seriesName2,
            data: JSON.parse(json.chartData2),
            color: '#6e06c1',
          }, {
            name: json.seriesName3,
            data: JSON.parse(json.chartData3),
            color: '#3a5cff',
          }],
          // Added for responsive. 2019 - 19 - 02 //
          responsive: {
            rules: [{
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  align: 'center',
                  verticalAlign: 'bottom',
                  layout: 'horizontal',
                },
                yAxis: {
                  labels: {
                    align: 'left',
                    x: 0,
                    y: -5,
                  },
                  title: {
                    text: null,
                  },
                },
                subtitle: {
                  text: null,
                },
                credits: {
                  enabled: false,
                },
              },
            }],
          }, // End addition //
        });
      });

      // AVERAGE-CHARGES-CHART //
      $.getJSON('/rrtpbillcompare/Servlet?type=average-electricity-charges-chart&account=' + $('#account-select #account').val(), function(json) {
        //console.log('average-charges-chart :: ');
        //console.log(json);
        // changes to make data conform to JSON spec
        json.chartData1 = json.chartData1.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        json.chartData2 = json.chartData2.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        json.chartData3 = json.chartData3.replace(/x/g, '"x"').replace(/y/g, '"y"').replace(/id/g, '"id"').replace(/'/g, '"');
        $('#spinner-average-charges-chart').hide();
        Highcharts.chart('average-electricity-charges-chart',{
          chart: {
            type: 'column',
            description: 'Total monthly electricity charges broken down by month for three years.',
            height: 230,
          },
          credits: {
            enabled: false,
          },
          title: {
            text: json.title,
            style: {
              color: '#170d67',
              fontFamily: 'Open Sans',
              fontWeight: '700',
            },
          },
          subtitle: {
            text: '',
          },
          xAxis: {
            lineColor: '#170d67',
            //categories: eval(json.xAxisCategories),  // if turned back on, change eval to JSON.parse.  May require changes in the data to confirm to JSON format
            labels: {
              formatter: function() {
                if (this.value == '1') return 'Jan';
                else if (this.value == '2') return 'Feb';
                else if (this.value == '3') return 'Mar';
                else if (this.value == '4') return 'Apr';
                else if (this.value == '5') return 'May';
                else if (this.value == '6') return 'Jun';
                else if (this.value == '7') return 'Jul';
                else if (this.value == '8') return 'Aug';
                else if (this.value == '9') return 'Sep';
                else if (this.value == '10') return 'Oct';
                else if (this.value == '11') return 'Nov';
                else if (this.value == '12') return 'Dec';
              },
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            },
          },
          yAxis: {
            lineColor: '#170d67',
            gridLineColor: '#170d67',
            title: {
              enabled: true,
              text: json.yAxis,
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            },
            labels: {
              style: {
                color: '#170d67',
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '0.666667rem',
              },
            }
          },
          tooltip: {
            //headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            //pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            //   '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
            //footerFormat: '</table>',
            enabled: true,
            headerFormat: '',
            pointFormat: '{point.y:.1f}¢',
            //shared: true,
            //useHTML: true
          },
          plotOptions: {
            series: {
              cursor: 'pointer',
              point: {
                events: {
                  click: function() {
                    //console.log('ID: ' + this.id + ' Name: ' + this.series.name + ' Category: ' + this.category + ', y: ' + this.y);
                    window.location = '/bc-graphs-daily?account=' + $('#account-select #account').val() + '&date=' + this.id;
                  },
                },
              },
              borderRadius: 0
            },
            column: {
              pointPadding: 0.2,
              borderWidth: 0,
            },
          },
          series: [{
            name: json.seriesName1,
            data: JSON.parse(json.chartData1),
            color: '#170d67',
          }, {
            name: json.seriesName2,
            data: JSON.parse(json.chartData2),
            color: '#6e06c1',
          }, {
            name: json.seriesName3,
            data: JSON.parse(json.chartData3),
            color: '#3a5cff',
          }],
          // Added for responsive. 2019 - 19 - 02 //
          responsive: {
            rules: [{
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  align: 'center',
                  verticalAlign: 'bottom',
                  layout: 'horizontal',
                },
                yAxis: {
                  lineColor: '#170d67',
                  gridLineColor: '#170d67',
                  labels: {
                    align: 'left',
                    x: 0,
                    y: -5,
                  },
                  title: {
                    text: null,
                  },
                },
                subtitle: {
                  text: null,
                },
                credits: {
                  enabled: false,
                },
              },
            }],
          }, // End addition //
        });
      });
    }

    mhpa.loadAccountData();
  },
  finalize() {
    // JavaScript to be fired on the graphs page, after the init JS
    $('#pick-date-start').datepicker({
      changeMonth: true,
      changeYear: true,
      maxDate: '+0',
    });
    $('#pick-date-end').datepicker({
      changeMonth: true,
      changeYear: true,
      maxDate: '+0',
    });
  },
};
